import { TESTIMONIALS } from "../../data/salon";
import { useStagger } from "../../lib/motion";
import { Stars } from "../ui/Bits";

export default function Voices() {
  const grid = useStagger({ step: 90 });

  return (
    <section className="voices">
      <div className="wrap wrap--wide">
        <div className="voices__head">
          <span className="eyebrow eyebrow--light">IN THEIR WORDS</span>
          <h2 className="voices__title">
            آنچه <em>مراجعه‌کننده‌ها</em> می‌گویند
          </h2>
        </div>

        <div className="voices__grid" ref={grid}>
          {TESTIMONIALS.map((t, i) => (
            <figure key={t.id} className={`voice voice--${i % 4} reveal`} data-stagger="">
              <span className="voice__quote" aria-hidden="true">”</span>
              <Stars rating={t.rating} />
              <blockquote>{t.body}</blockquote>
              <figcaption>
                <span className="voice__name">{t.name}</span>
                <span className="voice__meta">{t.city} · {t.service}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
